import useSWR from 'swr';

// Hooks
import useAcl from '@/hooks/user/useAcl';

// Libs
import { DATA_ACCESS } from '@/lib/acl/aclRightsList';
import { PERMISSIONS } from '@/lib/permissions/socialPermissions';
import { get } from '@/utils/client';
import { SETTINGS_DATA_ACCESS } from '@/routes/apiEndpoints';

// Types
import type { KeyedMutator, SWRConfiguration } from 'swr';
import type { EmailType } from '@/types/brandedTypes/email';

export type PermissionType =
    | typeof PERMISSIONS.ADS
    | typeof PERMISSIONS.ANALYTICS
    | typeof PERMISSIONS.SCHEDULER;

export type UserFBPermissionsType = {
    not_applicable: boolean;
    permissions: PermissionType[];
    user: {
        id: string;
        name: string;
        email: EmailType;
        picture: {
            data: {
                url: string;
                width: number;
                height: number;
                is_silhouette: boolean;
            };
        };
        short_name: string;
    };
    refresh_date: string;
};

export type MutateUserFBPermissions = KeyedMutator<UserFBPermissionsType>;

type UseUserFBPermissionsProps = {
    params?: { update?: '1' };
    options?: SWRConfiguration<UserFBPermissionsType, Error>;
};

const useUserFBPermissions = ({ params = {}, options = {} }: UseUserFBPermissionsProps = {}) => {
    const { hasAcl } = useAcl();

    const { data, mutate, error, isLoading } = useSWR<UserFBPermissionsType, Error>(
        hasAcl(DATA_ACCESS.read) ? [SETTINGS_DATA_ACCESS, JSON.stringify(params)] : null,
        ([url]) => get(url, params).then((res) => res.data),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    return {
        user: data,
        mutate,
        error,
        isLoading
    };
};
export default useUserFBPermissions;
